import React, { useState } from 'react';

import { Button } from 'flowbite-react';

import TextInput from '../../../../../../Form/TextInput';

import useUserRole from '../../../../../../../hooks/useUserRole';

export default function ExclusionReason({
  transactionId,
  isEditable,
  value,
  updateTransaction,
}) {
  const [reason, setReason] = useState(value || '');

  const { isOwner, isSuperAdmin } = useUserRole();

  if (!isEditable) {
    return null;
  }

  if (!isOwner && !isSuperAdmin) {
    return value;
  }

  return (
    <div>
      <div className="flex items-center gap-2">
        <TextInput
          value={reason}
          onChange={(event) => setReason(event.target.value)}
        />
        <Button
          onClick={() =>
            updateTransaction({
              formValues: {
                exclusionReason: reason,
              },
              id: transactionId,
            })
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
}
